var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "loginOTP" } },
    [
      _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "8" } },
                [
                  _c("v-img", {
                    staticClass: "mt-8 tl_logo",
                    staticStyle: { margin: "auto" },
                    attrs: {
                      src: require("../assets/img/logo-tl.png"),
                      width: "80"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "login_slim",
                  attrs: { cols: "12", sm: "8", md: "3" }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "login_card", attrs: { elevation: "10" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "login" },
                        [
                          !!_vm.message
                            ? _c("v-alert", { attrs: { type: "error" } }, [
                                _vm._v(" " + _vm._s(_vm.message))
                              ])
                            : _vm._e(),
                          _c(
                            "v-form",
                            {
                              attrs: { id: "login-form", autocomplete: "off" },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.submitLogin($event)
                                }
                              }
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: { align: "center", justify: "center" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "8", md: "8" } },
                                    [
                                      _c(
                                        "h1",
                                        {
                                          staticClass: "login_prihlasenie",
                                          attrs: { align: "center" }
                                        },
                                        [_vm._v("Prihlásenie SMS kódom")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    align: "center",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "8", md: "8" } },
                                    [
                                      _c(
                                        "form-component",
                                        { attrs: { title: "" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass:
                                              "dynamic-input-control",
                                            attrs: {
                                              "append-icon": _vm.showPass
                                                ? "mdi-eye"
                                                : "mdi-eye-off",
                                              rules: [_vm.rules.password],
                                              type: _vm.showPass
                                                ? "text"
                                                : "password",
                                              label: "SMS kód",
                                              outlined: ""
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                _vm.showPass = !_vm.showPass
                                              }
                                            },
                                            model: {
                                              value: _vm.password,
                                              callback: function($$v) {
                                                _vm.password = $$v
                                              },
                                              expression: "password"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "8", md: "8" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        type: "submit",
                                        color: "primary",
                                        form: "login-form",
                                        depressed: ""
                                      }
                                    },
                                    [_vm._v("Prihlásiť sa")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "v-copyright",
                  attrs: { align: "center", cols: "12", sm: "8", md: "8" }
                },
                [
                  _vm._v(" V spolupráci s "),
                  _c("b", [_vm._v("NCC a.s.")]),
                  _vm._v(" © " + _vm._s(_vm.year) + " ")
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }